import React, { Component } from "react";
import { ReviewResource } from "../../../../stores/ReviewsStore/Types";

interface Props {
  review: ReviewResource;
}

interface State {
  showModal: boolean;
}

class Review extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickShowModal = (e, val: boolean) => {
    e.preventDefault();
    this.setState({ showModal: val });
  };

  render() {
    const { review } = this.props;
    const { showModal } = this.state;
    const hasLongContent = review.content.length > 140;
    const contentPreview = hasLongContent
      ? `${review.content.slice(0, 140).trim()}...`
      : review.content;
    // Last resort only: ReviewSerializer now resolves archived authors, so a
    // card should always have a country. Format the date rather than falling
    // through to review.created_at, which printed the raw stored string
    // "2019-11-22T18:42:31.812Z" onto the card when the author was archived.
    const reviewedOn = review.created_at
      ? new Date(review.created_at).toLocaleDateString("en-GB", {
          month: "long",
          year: "numeric",
          // Stored in UTC. Without this a review written just after midnight
          // shows the previous month to anyone west of London.
          timeZone: "UTC",
        })
      : "";
    const authorMeta =
      review.company_name || review.user_country_name || reviewedOn;
    const rating = Math.min(Math.max(review.rating || 5, 0), 5);
    const stars = "★".repeat(rating) + "☆".repeat(5 - rating);

    return (
      <>
        <article className="review-card">
          <div className="stars" aria-label={`${rating} out of 5 stars`}>
            {stars}
          </div>
          <p>
            "{contentPreview}"
            {hasLongContent && (
              <>
                {" "}
                <a onClick={(e) => this.onClickShowModal(e, true)} href="#">
                  Read more
                </a>
              </>
            )}
          </p>
          <div className="author-row">
            <div className="author-pic" aria-hidden={!review.profile_picture}>
              {review.profile_picture && (
                <img src={review.profile_picture} alt={review.user_name} />
              )}
            </div>
            <div>
              <div className="author-name">{review.user_name}</div>
              {authorMeta && <div className="author-meta">{authorMeta}</div>}
            </div>
          </div>
        </article>

        {showModal && (
          <div
            className="content-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby={`review-modal-title-${review.id}`}
            aria-hidden="false"
          >
            <button
              type="button"
              className="content-modal-backdrop"
              aria-label="Close"
              onClick={(e) => this.onClickShowModal(e, false)}
            />
            <div className="content-modal-panel" role="document">
              <button
                type="button"
                className="content-modal-close"
                aria-label="Close"
                onClick={(e) => this.onClickShowModal(e, false)}
              >
                ×
              </button>
              <header className="content-modal-header">
                <p className="content-modal-eyebrow">Learner review</p>
                <h2
                  className="content-modal-title"
                  id={`review-modal-title-${review.id}`}
                >
                  {review.user_name}
                </h2>
              </header>
              <div className="content-modal-body">
                <p>{review.content}</p>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Review;
